export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/UnitedKingdom-58a32a2e1ad988c18f7a7d386a6552ac.mp3";